// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Header-module--bx--text-truncate--end--M4qNH";
export var bxTextTruncateFront = "Header-module--bx--text-truncate--front--RVR+C";
export var header = "Header-module--header--GJDvk";
export var headerButton = "Header-module--header-button--cTW-C";
export var headerName = "Header-module--headerName--01F2z";
export var headerNameWithHeaderNav = "Header-module--headerNameWithHeaderNav--GtlR2";
export var headerWithHeaderNav = "Header-module--headerWithHeaderNav--PQydz";
export var searchIsOpenOnBar = "Header-module--searchIsOpenOnBar--dUXTP";
export var searchIsOpenOnLink = "Header-module--searchIsOpenOnLink--IgxqT";
export var skipToContent = "Header-module--skip-to-content--K2bst";
export var switcherButton = "Header-module--switcher-button--FrOpW";
export var switcherButtonOpen = "Header-module--switcher-button--open--AXf17";